import config from './config';
import colaboradorFactory from './colaboradores';
import { Colaborador } from './colaborador';
import safraFactory from './configuracoes/safra';
import parametrosContaFactory from './configuracoes/parametrosConta';
import authFactory from './auth';
import favoritesFactory from './favorites';
import logsFactory from './logs';
import caldaFactory from './calda';
import atividadeFactory from './configuracoes/atividade';
import { TagsFactory } from './attachments/tags';
import { MitigationsFactory } from './global/mitigations';
import regAtividadeFactory from './regAtividades';
import insumoFactory from './insumo';
import ProdutosFactory from './produtos';
import ProductsFactory from './products';
import MaquinaFactory from './maquina';
import talhaoFactory from './talhao';
import { EstoqueProdFactory } from './estoqueProd';
import { CatLancamentosFactory } from './configuracoes/catLancamentos';
import turmaFactory from './turma';
import fazendaFactory from './fazenda';
import implementoFactory from './implemento';
import historicoFactory from './insumo/historico';
import folhaMensalistaFactory from './folhaMensalista';
import folhaColheitaFactory from './folhaColheita';
import fluxoFactory from './financeiro/fluxo';
import openFinanceFactory from './financeiro/openFinance';
import pagamentoFactory from './configuracoes/pagamento';
import estoqueFactory from './configuracoes/estoque';
import funcaoFactory from './configuracoes/funcao';
import apontamentoFactory from './configuracoes/apontamento';
import qualidadeCafeFactory from './configuracoes/qualidadeCafe';
import usuarioFactory from './configuracoes/usuario';
import centroCustoFactory from './configuracoes/centroCusto';
import acompanhamentoFactory from './colheita/acompanhamento';
import { ColheitaFactory } from './colheita';
import financeiroFactory from './financeiro';
import financeiroPlanejamentoFactory from './financeiro/planejamento';
import relatoriosPersonalizadosFactory from './financeiro/relatoriosPersonalizados';
import rateioTemplatesFactory from './financeiro/rateioTemplates';
import fornecedorFactory from './fornecedores';
import clienteFactory from './clientes';
import cadEstoqueFactory from './cadEstoque';
import tutorialFactory from './tutorial';
import dreFactory from './dre';
import dadosCadastroFactory from './dadosCadastro';
import configGeraisFactory from './gerais';
import { VendaFactory } from './vendas';
import despolpadorFactory from './rastreabilidade/despolpador';
import terreiroFactory from './rastreabilidade/terreiro';
import secadorFactory from './rastreabilidade/secador';
import armazemFactory from './rastreabilidade/armazem';
import lotesFactory from './rastreabilidade/lotes';
import responsaveisFactory from './rastreabilidade/responsaveis';

import { CadFermentadorFactory } from './cadRastreabilidade/cadFermentadores';
import cadArmazemFactory from './cadRastreabilidade/cadArmazens';
import { CadPilhasFactory } from './cadRastreabilidade/cadPilhas';
import cadSecadorFactory from './cadRastreabilidade/cadSecadores';
import cadBagFactory from './cadRastreabilidade/cadBags';
import cadCooperativesFactory from './cadRastreabilidade/cadCooperatives';

import cadTerreiroFactory from './cadRastreabilidade/cadTerreiros';
import { BeneficioFactory } from './rastreabilidade/beneficio';
import { CooperativaDepositoFactory } from './rastreabilidade/cooperativaDeposito';
import { RebeneficioFactory } from './rastreabilidade/rebeneficio';
import { AbastecimentoFactory } from './abastecimento';
import { ManutencaoFactory } from './manutencao';
import contratosParceriasFactory from './contratosParcerias';
import { RelInsumosFactory } from './relatorios/insumos';
import { HelpContentsFactory } from './helpContents';
import { CourseVideosFactory } from './courseVideos';
import { CourseFoldersFactory } from './courseFolders';

import { PermissionsFactory } from './permissions';
import { RelTalhoesFactory } from './relatorios/talhoes';
import RelMensalFactory from './relatorios/mensal';
import { RelAnualFactory } from './relatorios/anual';
import { RelIndiretosFactory } from './relatorios/indiretos';
import { RelFinanceiroFactory } from './relatorios/financeiro';
import cadInventario from './inventario';
import marcacaoCachosFactory from './marcacaoCachos';
import cortesCachosFactory from './cortesCachos';
import catUnidadesFracaoFactory from './catUnidadesFracao';
import { CompraFactory } from './compras';
import RelDreFactory from './relatorios/dre';
import { PlanejamentoFactory } from './planejamento';
import { EstimativaFactory } from './estimativa';
import { ReciboFactory } from './recibos';
import { RelColaboradoresFactory } from './relatorios/colaboradores';
import { RelatoriosSafrasFactory } from './relatorios/safras';
import { PrestacaoServicosFactory } from './prestacaoServicos';
import { ServicosFactory } from './configuracoes/servicos';
import { InvoiceFactory } from './invoice';
import { CatalogoDefensivosFactory } from './catalogoDefensivos';
import { FileFactory } from './file';
import { GalleryPhotosFactory } from './gallery-photos';
import { DashboardFactory } from './dashboard';
import { AgronomistFactory } from './agronomist';
import { NotificationsFactory } from './notifications';
import { MipFactory } from './mip';
import { CertificationsFactory } from './certifications/certifications';
import { MyCertificationFactory } from './certifications/my-certification';
import { SalesTypes } from './salesTypes';
import { SalesTypesMovimentacoes } from './salesTypesMovimentacoes';
import { EstoqueProducaoAvulsaFactory } from './estoqueProducaoAvulsa';
import { NfeFactory } from './nfe';
import { FiscalFactory } from './fiscal';
import { DigitalCertificatesFactory } from './digital-certificates';
import { OrdemDeServicoFactory } from './ordemDeServico';
import npsFactory from './nps';
import { MachineAlertsFactory } from './alertasMaquina';

import { DocumentExtractionFactory } from './document-extraction';

import { LancamentoAtividadeFactory } from './lancamento-atividade';
import oauthFactory from './oauth';
import { GalleryTagsFactory } from './gallery-tags';

import pontoEletronicoFactory from './ponto-eletronico';
import coletorFactory from './coletor';
import viveiroFactory from './viveiro';
import { ProductAssistantFactory } from './product-assistant';
import { AgrogerIaFactory } from './agroger-ia';



export class Api {
  constructor(params) {
    this.instance = config(params, true).instance();
  }

  salesTypes() {
    return new SalesTypes(this.instance);
  }

  salesTypesMovimentacoes() {
    return new SalesTypesMovimentacoes(this.instance);
  }

  estoqueProducaoAvulsa() {
    return new EstoqueProducaoAvulsaFactory(this.instance);
  }

  agronomist() {
    return new AgronomistFactory(this.instance);
  }

  notifications() {
    return new NotificationsFactory(this.instance);
  }

  mip() {
    return new MipFactory(this.instance);
  }

  despolpador() {
    return despolpadorFactory(this.instance);
  }

  file() {
    return new FileFactory(this.instance);
  }

  galleryPhotos() {
    return new GalleryPhotosFactory(this.instance);
  }

  galleryTags() {
    return new GalleryTagsFactory(this.instance);
  }

  relatoriosColaboradores() {
    return new RelColaboradoresFactory(this.instance);
  }

  dashboard() {
    return new DashboardFactory(this.instance);
  }

  permissions() {
    return new PermissionsFactory(this.instance);
  }

  invoice() {
    return new InvoiceFactory(this.instance);
  }

  catalogoDefensivos() {
    return new CatalogoDefensivosFactory(this.instance);
  }

  estimativa() {
    return new EstimativaFactory(this.instance);
  }

  planejamento() {
    return new PlanejamentoFactory(this.instance);
  }

  relAnual() {
    return new RelAnualFactory(this.instance);
  }

  relIndiretos() {
    return new RelIndiretosFactory(this.instance);
  }

  contratosParcerias() {
    return contratosParceriasFactory(this.instance);
  }

  estoqueProd() {
    return new EstoqueProdFactory(this.instance);
  }

  compras() {
    return new CompraFactory(this.instance);
  }

  colheita() {
    return new ColheitaFactory(this.instance);
  }

  terreiro() {
    return terreiroFactory(this.instance);
  }

  abastecimento() {
    return new AbastecimentoFactory(this.instance);
  }

  manutencao() {
    return new ManutencaoFactory(this.instance);
  }

  cadTerreiro() {
    return cadTerreiroFactory(this.instance);
  }

  secador() {
    return secadorFactory(this.instance);
  }

  cadSecador() {
    return cadSecadorFactory(this.instance);
  }

  cadBag() {
    return cadBagFactory(this.instance);
  }

  cadCooperative() {
    return cadCooperativesFactory(this.instance);
  }

  armazem() {
    return armazemFactory(this.instance);
  }

  cadFermentador() {
    return new CadFermentadorFactory(this.instance);
  }

  cadArmazem() {
    return cadArmazemFactory(this.instance);
  }

  pilha() {
    return new CadPilhasFactory(this.instance);
  }

  beneficio() {
    return new BeneficioFactory(this.instance);
  }

  cooperativaDeposito() {
    return new CooperativaDepositoFactory(this.instance);
  }

  rebeneficio() {
    return new RebeneficioFactory(this.instance);
  }

  lotes() {
    return lotesFactory(this.instance);
  }

  responsaveis() {
    return responsaveisFactory(this.instance);
  }

  dadosCadastro() {
    return dadosCadastroFactory(this.instance);
  }

  gerais() {
    return configGeraisFactory(this.instance);
  }

  atividade() {
    return atividadeFactory(this.instance);
  }

  tags() {
    return new TagsFactory(this.instance);
  }

  mitigations() {
    return new MitigationsFactory(this.instance);
  }

  tutorial() {
    return tutorialFactory(this.instance);
  }

  dre() {
    return dreFactory(this.instance);
  }

  cadEstoque() {
    return cadEstoqueFactory(this.instance);
  }

  cliente() {
    return clienteFactory(this.instance);
  }

  fornecedor() {
    return fornecedorFactory(this.instance);
  }

  acompanhamento() {
    return acompanhamentoFactory(this.instance);
  }

  pagamento() {
    return pagamentoFactory(this.instance);
  }

  centroCusto() {
    return centroCustoFactory(this.instance);
  }

  usuario() {
    return usuarioFactory(this.instance);
  }

  qualidade_cafe() {
    return qualidadeCafeFactory(this.instance);
  }

  apontamento() {
    return apontamentoFactory(this.instance);
  }

  estoque() {
    return estoqueFactory(this.instance);
  }

  colaborador() {
    return colaboradorFactory(this.instance);
  }

  colaboradores() {
    return new Colaborador(this.instance);
  }

  folhaMensalista() {
    return folhaMensalistaFactory(this.instance);
  }

  folhaColheita() {
    return folhaColheitaFactory(this.instance);
  }

  calda() {
    return caldaFactory(this.instance);
  }

  vendas() {
    return new VendaFactory(this.instance);
  }

  fluxo() {
    return fluxoFactory(this.instance);
  }

  openFinance() {
    return openFinanceFactory(this.instance);
  }

  insumo() {
    return insumoFactory(this.instance);
  }

  helpContents() {
    return new HelpContentsFactory(this.instance);
  }

  courseVideos() {
    return new CourseVideosFactory(this.instance);
  }

  courseFolders() {
    return new CourseFoldersFactory(this.instance);
  }

  ordemDeServico() {
    return new OrdemDeServicoFactory(this.instance);
  }

  produtos() {
    return new ProdutosFactory(this.instance);
  }

  products() {
    return new ProductsFactory(this.instance);
  }

  historico() {
    return historicoFactory(this.instance);
  }

  talhao() {
    return talhaoFactory(this.instance);
  }

  implemento() {
    return implementoFactory(this.instance);
  }

  financeiro() {
    return financeiroFactory(this.instance);
  }

  planejamentoFinanceiro() {
    return financeiroPlanejamentoFactory(this.instance);
  }

  relatoriosPersonalizados() {
    return relatoriosPersonalizadosFactory(this.instance);
  }

  rateioTemplates() {
    return rateioTemplatesFactory(this.instance);
  }

  turma() {
    return turmaFactory(this.instance);
  }

  funcao() {
    return funcaoFactory(this.instance);
  }

  fazenda() {
    return fazendaFactory(this.instance);
  }

  catLancamentos() {
    return new CatLancamentosFactory(this.instance);
  }

  regAtividade() {
    return regAtividadeFactory(this.instance);
  }

  maquina() {
    return new MaquinaFactory(this.instance);
  }

  auth() {
    return authFactory(this.instance);
  }

  favorites() {
    return favoritesFactory(this.instance);
  }

  logs() {
    return logsFactory(this.instance);
  }

  safras() {
    return safraFactory(this.instance);
  }

  relInsumos() {
    return new RelInsumosFactory(this.instance);
  }

  relTalhoes() {
    return new RelTalhoesFactory(this.instance);
  }

  relMensal() {
    return new RelMensalFactory(this.instance);
  }

  parametrosConta() {
    return parametrosContaFactory(this.instance);
  }

  inventario() {
    return cadInventario(this.instance);
  }

  marcacaoCachos() {
    return marcacaoCachosFactory(this.instance);
  }

  cortesCachos() {
    return cortesCachosFactory(this.instance);
  }

  catUnidadesFracao() {
    return catUnidadesFracaoFactory(this.instance);
  }

  relDreFactory() {
    return new RelDreFactory(this.instance);
  }

  relFinanceiro() {
    return new RelFinanceiroFactory(this.instance);
  }

  relatoriosSafras() {
    return new RelatoriosSafrasFactory(this.instance);
  }

  recibos() {
    return new ReciboFactory(this.instance);
  }

  servicosFactory() {
    return new ServicosFactory(this.instance);
  }

  prestacaoServicos() {
    return new PrestacaoServicosFactory(this.instance);
  }

  certifications() {
    return new CertificationsFactory(this.instance);
  }

  myCertification() {
    return new MyCertificationFactory(this.instance);
  }

  nfe() {
    return new NfeFactory(this.instance);
  }

  fiscal() {
    return new FiscalFactory(this.instance);
  }

  digitalCertificates() {
    return new DigitalCertificatesFactory(this.instance);
  }

  machineAlerts() {
    return new MachineAlertsFactory(this.instance);
  }

  documentExtraction() {
    return new DocumentExtractionFactory(this.instance);
  }

  lancamentoAtividade() {
    return new LancamentoAtividadeFactory(this.instance);
  }

  nps() {
    return npsFactory(this.instance);
  }

  pontoEletronico() {
    return pontoEletronicoFactory(this.instance);
  }

  coletor() {
    return coletorFactory(this.instance);
  }

  viveiro() {
    return viveiroFactory(this.instance);
  }

  productAssistant() {
    return new ProductAssistantFactory(this.instance);
  }

  agrogerIa() {
    return new AgrogerIaFactory(this.instance);
  }

  oauth() {
    return oauthFactory(this.instance);
  }
}

export default (params) => new Api(params);

